export const breachConstants = {
    SEARCH_REQUEST: 'BREACH_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'BREACH_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'BREACH_SEARCH_FAILURE',
    SEARCH_FAILURE_DONE: 'BREACH_SEARCH_FAILURE_DONE',
};